import axiosInstance from '../axios/axiosInstance';
import { TestBank } from '../model/response';

export const findAllTestBank = async () => {
  const { data } = await axiosInstance.get<TestBank[]>('test-banks', { params: { fromCMS: true } });
  return data;
};

export const editTestBank = async (id: string | undefined, newTestBank: string) => {
  await axiosInstance.put(`/test-banks/${id}`, {
    name: newTestBank,
  });
};

export const deleteTestBank = async (id: string | undefined) => {
  await axiosInstance.delete(`/test-banks/${id}`);
};
